import useSWR from 'swr'
import { useTranslation } from 'react-i18next'

import { fetchLoanApplication } from 'facades/fetchLoanApplication'
import { fetchStatusLabel } from 'facades/fetchStatusLabel'
import { fetchRecurrentLead } from 'facades/fetchRecurrentLead'

const useFetchStatusLabel = (
  applicationId: string,
  pipelineStatus: string,
  cpf: string,
) => {
  const { t } = useTranslation(['assignments'])
  const { data: loanApplication } = useSWR(
    ['loan-application', applicationId],
    () => fetchLoanApplication(applicationId),
  )
  const { data: recurrentLead } = useSWR(['recurrent-lead', cpf], () =>
    fetchRecurrentLead(cpf),
  )
  const { data } = useSWR(['status-label', applicationId], () =>
    fetchStatusLabel(
      applicationId,
      t,
      pipelineStatus,
      loanApplication.professionalStatus,
      loanApplication.vehicleOwner,
      recurrentLead?.isRecurrent,
    ),
  )

  return data
}

export { useFetchStatusLabel }
